import { ProjectStateType } from "../EditProjectContext";
import { FtlRouteViewModel } from "../../ViewModel/FtlRouteViewModel";
import { PdsrClientViewModel } from "../../ViewModel/PdsrClientViewModel";

export const setPdsrsOnThisRoute = (
  projectState: ProjectStateType,
  routeId: number,
  pdsrsOnThisRoute?: Array<PdsrClientViewModel>
) => {
  const { project, setProject } = projectState;

  const updateFtlRoute = (ftlRoute: FtlRouteViewModel) => {
    return ftlRoute.RouteId === routeId
      ? {
          ...ftlRoute,
          PdsrsOnThisRoute: pdsrsOnThisRoute,
        }
      : ftlRoute;
  };

  setProject({
    ...project,
    FTLRoutes: project?.FTLRoutes?.map(updateFtlRoute),
  });
};
